import { useCheckPermissions } from '@/shared';
import { SaveEntidadesFinancieras } from '../../shared/saveEntidadesFinancieras';
import { PermissionsEnum } from '@/auth/interfaces';

export interface CreateEntidadesFinancierasPageInterface {}

const CreateEntidadesFinancierasPage: React.FC<CreateEntidadesFinancierasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_add_entidadfinanciera)
  return <SaveEntidadesFinancieras titlePage="Crear Entidades financieras" />;
};

export default CreateEntidadesFinancierasPage;
